"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const R = __importStar(require("ramda"));
const utils_1 = require("@8base/utils");
const qs_1 = __importDefault(require("qs"));
const jwt_decode_1 = __importDefault(require("jwt-decode"));
const isEmptyOrNil = R.either(R.isNil, R.isEmpty);
/**
 * Creates instance of the web Cognito auth client.
 */
class WebCognitoAuthClient {
    constructor(options, storageOptions = {}) {
        utils_1.throwIfMissingRequiredParameters(['domain', 'clientId', 'redirectUri'], utils_1.PACKAGES.WEB_COGNITO_AUTH_CLIENT, options);
        const { logoutRedirectUri, clientId, redirectUri, domain } = options;
        this.storageAPI = new utils_1.StorageAPI(storageOptions.storage || window.localStorage, storageOptions.storageKey || 'auth', storageOptions.initialState);
        this.logoutHasCalled = false;
        this.clientId = clientId;
        this.redirectUri = redirectUri;
        this.logoutRedirectUri = logoutRedirectUri;
        this.domain = domain;
    }
    setState(state) {
        this.storageAPI.setState(state);
    }
    getState() {
        return this.storageAPI.getState();
    }
    purgeState() {
        this.storageAPI.purgeState();
    }
    checkIsAuthorized() {
        const { token } = this.getState();
        return R.not(isEmptyOrNil(token));
    }
    authorize(options = {}) {
        const link = `${this.domain}/oauth2/authorize?${qs_1.default.stringify({
            client_id: this.clientId,
            response_type: 'token',
            redirect_uri: this.redirectUri,
        }, {
            encode: false,
        })}`;
        window.location.replace(link);
    }
    checkSession(options = {}) {
        return null;
    }
    getAuthorizedData() {
        const querySearch = window.location.href.split('#')[1];
        const result = qs_1.default.parse(querySearch);
        const jwtResult = jwt_decode_1.default(result.id_token);
        return {
            idToken: result.id_token,
            accessToken: result.access_token,
            state: result.state,
            firstName: jwtResult.name,
            lastName: jwtResult.family_name,
            email: jwtResult.email,
        };
    }
    getTokenInfo() {
        const { token } = this.getState();
        if (!token) {
            return undefined;
        }
        return jwt_decode_1.default(token) || undefined;
    }
    logout(options = {}) {
        window.addEventListener('unload', () => {
            this.purgeState();
        });
        window.location.replace(`${this.domain}/logout?${qs_1.default.stringify({
            client_id: this.clientId,
            response_type: 'token',
            redirect_uri: this.redirectUri,
        }, {
            encode: false,
        })}`);
    }
}
exports.WebCognitoAuthClient = WebCognitoAuthClient;
//# sourceMappingURL=WebAuthCognitoClient.js.map